import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutSmsQuickInfo extends Layout {
    sourceCarrierDriverMessage: DataSource;
    table1: Table;
}
